import { Ban, Download, Eye, FilePlus, Pencil, Printer, RefreshCw, Search, Send, ShoppingCart } from "lucide-react";
import Notification from "../../components/toast";

export const MODELOS = { 55: "NF-e", 65: "NFC-e" };

export const TONS = {
	verde: "bg-emerald-50 text-emerald-700 border-emerald-200",
	vermelho: "bg-red-50 text-red-700 border-red-200",
	ambar: "bg-amber-50 text-amber-700 border-amber-200",
	cinza: "bg-gray-100 text-gray-600 border-gray-200",
};

export const ACOES = {
	visualizar: { rotulo: "Visualizar", icone: Eye, aba: "resumo" },
	venda: { rotulo: "Ver venda", icone: ShoppingCart, aba: "venda" },
	analisar: { rotulo: "Analisar", icone: Search, painelNumero: true },
	imprimir: { rotulo: "Imprimir", icone: Printer },
	baixarXml: { rotulo: "Baixar XML", icone: Download },
	consultar: { rotulo: "Consultar na SEFAZ", icone: RefreshCw, exibeRetorno: true },
	corrigir: { rotulo: "Corrigir", icone: Pencil },
	reenviar: { rotulo: "Reenviar", icone: Send },
	transmitir: { rotulo: "Transmitir", icone: Send, sucesso: "autorizada na SEFAZ" },
	emitir: { rotulo: "Emitir", icone: FilePlus },
	cancelar: { rotulo: "Cancelar", icone: Ban, perigo: true, justificativa: true, sucesso: "cancelada na SEFAZ" },
	inutilizar: { rotulo: "Inutilizar", icone: Ban, perigo: true, justificativa: true, sucesso: "inutilizada na SEFAZ" },
};

export const STATUS = {
	AUTORIZADA: { rotulo: "Autorizada", tom: "verde", acoes: ["imprimir", "baixarXml", "consultar", "cancelar"] },
	CANCELADA: { rotulo: "Cancelada", tom: "cinza", acoes: ["imprimir", "baixarXml"] },
	DENEGADA: { rotulo: "Denegada", tom: "vermelho", acoes: ["baixarXml"] },
	INUTILIZADA: { rotulo: "Inutilizada", tom: "cinza", acoes: [] },
	REJEITADA: { rotulo: "Rejeitada", tom: "vermelho" },
	ERRO: { rotulo: "Erro", tom: "vermelho" },
	GERADA: { rotulo: "Gerada", tom: "ambar" },
	EM_MONTAGEM: { rotulo: "Em montagem", tom: "ambar" },
	CONTINGENCIA: { rotulo: "Contingência", tom: "ambar" },
	CONT_REJEITADA: { rotulo: "Contingência rejeitada", tom: "vermelho" },
};

export const CONSOLIDADOS = ["AUTORIZADA", "CANCELADA", "DENEGADA"];

export const SITUACOES_NUMERO = {
	...STATUS,
	NAO_LOCALIZADO: { rotulo: "Não localizado", tom: "vermelho" },
};

export function descrever(item) {
	return item.numero ? `${MODELOS[item.modelo]} nº ${item.numero}` : `Venda ${item.id_venda}`;
}

export function simularAcao(acao, item) {
	Notification.showToast({
		message: `Simulação: ${ACOES[acao].rotulo} — ${descrever(item)}. Nenhuma operação foi executada.`,
		type: "info",
	});
}
